import { useEffect, useRef, useState } from 'react';

import Button from 'components/shared/Buttons/Button/Button';
import Input from 'components/shared/Input/Input';

const TextInput = ({ initialOpenState = false, values, onApply, ...rest }) => {
  const [inputValues, setInputValues] = useState(values);
  const [open, setOpen] = useState(initialOpenState);
  const inputRef = useRef(null);

  useEffect(() => {
    if (open && inputRef.current) {
      setTimeout(() => {
        inputRef.current.focus();
      }, 100);
    }
  }, [open]);

  const onApplyHandler = () => {
    onApply(inputValues);
    setOpen(false);
  };

  const onChange = (value) => {
    setInputValues(value);
  };

  const isDisabled = !inputValues;

  const buttonText = values || 'Enter text';

  return (
    <div className="relative">
      <Button
        onClick={() => setOpen((prev) => !prev)}
        className="whitespace-nowrap"
        text={buttonText}
        {...rest}
      />
      {open && (
        <div className="absolute left-0 z-10 mt-2 flex w-fit items-center gap-2 rounded bg-white p-2 shadow-xs">
          <Input
            forwardedRef={inputRef}
            type="text"
            placeholder="Enter text..."
            inputWrapperClassName="w-[172px] min-w-[172px]"
            value={inputValues}
            onChange={(e) => onChange(e.target.value)}
          />
          <Button text="Apply" onClick={onApplyHandler} isDisabled={isDisabled} />
        </div>
      )}
    </div>
  );
};

export default TextInput;
